import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class EventLandingEndpoint extends BaseEndpoint {}
